import React from "react";


export interface IconProps {
  color?: string;
}

export interface StrokeWidthIconProps extends IconProps {
  strokeWidth?: string;
}

const iconWidth = 30;
const iconHeight = 30;

// Groundlight Icon used on the Appbar
export function GroundlightIcon({ color = "#ffffff" }: IconProps) {
  return (
    <svg data-testid="groundlight-icon" width={iconWidth} height={iconHeight} viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
      <g transform="translate(0, 3.5)">
        <path
          d="M13.989 18.128H0V15.804H13.989C14.835 15.804 15.524 15.108 15.524 14.256V12.918L16.681 12.107L17.838 12.918V14.256C17.838 16.388 16.112 18.128 13.991 18.128H13.989Z"
          fill="url(#gradient-1)"
        />
        <path
          d="M8.443 5.938L7.287 6.75L6.131 5.938V4.6C6.131 2.468 7.857 0.728 10.139 0.728H23.965V2.906H10.141C9.295 2.906 8.443 3.676 8.443 4.6V5.938Z"
          fill="url(#gradient-2)"
        />
        <path
          d="M6.131 13.479L5.04 14.291L3.948 13.479V12.141C3.948 10.009 5.674 8.269 7.956 8.269H16.299C17.145 8.269 17.838 7.573 17.838 6.721V5.383L18.995 4.572L20.152 5.383V6.721C20.152 8.853 18.426 10.593 16.144 10.593H7.958C7.112 10.593 6.131 11.288 6.131 12.141V13.479Z"
          fill={color}
        />
      </g>
      <defs>
        <linearGradient
          id="gradient-1"
          x1="0"
          y1="15.121"
          x2="17.836"
          y2="15.121"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor={color} stopOpacity="0" />
          <stop offset="1" stopColor={color} />
        </linearGradient>
        <linearGradient
          id="gradient-2"
          x1="6.131"
          y1="3.742"
          x2="23.965"
          y2="3.742"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor={color} />
          <stop offset="1" stopColor={color} stopOpacity="0" />
        </linearGradient>
      </defs>
    </svg>
  );
}

export const ConnectedHubIcon = ({ color = "#2DC937" }: IconProps) => (
  <svg data-testid="connected-hub-icon" width={iconWidth} height={iconHeight} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M15 19C15 18.7348 14.8946 18.4804 14.7071 18.2929C14.5196 18.1054 14.2652 18 14 18H13V16H17C17.5304 16 18.0391 15.7893 18.4142 15.4142C18.7893 15.0391 19 14.5304 19 14V4C19 3.46957 18.7893 2.96086 18.4142 2.58579C18.0391 2.21071 17.5304 2 17 2H7C6.46957 2 5.96086 2.21071 5.58579 2.58579C5.21071 2.96086 5 3.46957 5 4V14C5 14.5304 5.21071 15.0391 5.58579 15.4142C5.96086 15.7893 6.46957 16 7 16H11V18H10C9.73478 18 9.48043 18.1054 9.29289 18.2929C9.10536 18.4804 9 18.7348 9 19H2V21H9C9 21.2652 9.10536 21.5196 9.29289 21.7071C9.48043 21.8946 9.73478 22 10 22H14C14.2652 22 14.5196 21.8946 14.7071 21.7071C14.8946 21.5196 15 21.2652 15 21H22V19H15ZM7 14V4H17V14H7ZM8 9.37L9.24 8.13L10.93 9.83L14.76 6L16 7.5L10.93 12.57L8 9.37Z"
      fill={color}
    />
  </svg>
);

export const DisconnectedHubIcon = ({ color = "#919599" }: IconProps) => (
  <svg data-testid="disconnected-hub-icon" width={iconWidth} height={iconHeight} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M1.03906 4.27L4.99906 8.23V14C4.99906 14.5304 5.20978 15.0391 5.58485 15.4142C5.95992 15.7893 6.46863 16 6.99906 16H10.9991V18H9.99906C9.73385 18 9.47949 18.1054 9.29196 18.2929C9.10442 18.4804 8.99906 18.7348 8.99906 19H1.99906V21H8.99906C8.99906 21.2652 9.10442 21.5196 9.29196 21.7071C9.47949 21.8946 9.73385 22 9.99906 22H13.9991C14.2643 22 14.5186 21.8946 14.7062 21.7071C14.8937 21.5196 14.9991 21.2652 14.9991 21H17.7691L19.7691 23L21.0391 21.72L2.31906 3L1.03906 4.27ZM6.99906 10.23L10.7691 14H6.99906V10.23ZM14.9991 19C14.9991 18.7348 14.8937 18.4804 14.7062 18.2929C14.5186 18.1054 14.2643 18 13.9991 18H12.9991V16.23L15.7691 19H14.9991ZM21.9991 19V20.14L20.8591 19H21.9991ZM6.99906 5.14L5.13906 3.28C5.42906 2.53 6.15906 2 6.99906 2H16.9991C17.5295 2 18.0382 2.21071 18.4133 2.58579C18.7883 2.96086 18.9991 3.46957 18.9991 4V14C18.9991 14.85 18.4691 15.57 17.7191 15.86L15.8591 14H16.9991V4H6.99906V5.14Z"
      fill={color}
    />
  </svg>
);

// Microscope Icon that represent Detectors
export const BiotechIcon = ({ color = "#ffffff" }: IconProps) => (
  <svg data-testid="biotech-icon" width={iconWidth} height={iconHeight} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      transform="translate(3, 2)"
      d="M18 5V20H0V18H16V5H11.72C11.38 5.6 10.74 6 10 6C10 7.11 9.1 8 8 8H5C3.9 8 3 7.1 3 6V2C3 0.9 3.9 0 5 0H8C9.1 0 10 0.9 10 2C10.74 2 11.38 2.41 11.72 3H16C17.11 3 18 3.89 18 5ZM3 13H10L8 9H5L3 13Z"
      fill={color}
    />
  </svg>
);

// Awaiting Label Icon
export const WaitingUserIcon = ({ color = "#ffffff" }: IconProps) => (
  <svg data-testid="waiting-user-icon" width={iconWidth} height={iconHeight} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g transform="translate(2.5, 2.5) scale(0.8)">
      <path
        transform="translate(0.5, 2)"
        d="M15 10H16.5V12.82L18.94 14.23L18.19 15.53L15 13.69V10ZM16 8C14.6739 8 13.4021 8.52678 12.4645 9.46447C11.5268 10.4021 11 11.6739 11 13C11 14.3261 11.5268 15.5979 12.4645 16.5355C13.4021 17.4732 14.6739 18 16 18C17.3261 18 18.5979 17.4732 19.5355 16.5355C20.4732 15.5979 21 14.3261 21 13C21 11.6739 20.4732 10.4021 19.5355 9.46447C18.5979 8.52678 17.3261 8 16 8ZM16 6C17.8565 6 19.637 6.7375 20.9497 8.05025C22.2625 9.36301 23 11.1435 23 13C23 14.8565 22.2625 16.637 20.9497 17.9497C19.637 19.2625 17.8565 20 16 20C13.21 20 10.8 18.36 9.67 16H0V13C0 10.34 5.33 9 8 9C8.6 9 9.34 9.07 10.12 9.2C11.36 7.28 13.53 6 16 6ZM9 13C9 12.3 9.1 11.62 9.29 11C8.87 10.93 8.43 10.9 8 10.9C5.03 10.9 1.9 12.36 1.9 13V14.1H9.09C9.03 13.74 9 13.37 9 13ZM8 0C9.06087 0 10.0783 0.421427 10.8284 1.17157C11.5786 1.92172 12 2.93913 12 4C12 5.06087 11.5786 6.07828 10.8284 6.82843C10.0783 7.57857 9.06087 8 8 8C6.93913 8 5.92172 7.57857 5.17157 6.82843C4.42143 6.07828 4 5.06087 4 4C4 2.93913 4.42143 1.92172 5.17157 1.17157C5.92172 0.421427 6.93913 0 8 0ZM8 1.9C7.44305 1.9 6.9089 2.12125 6.51508 2.51508C6.12125 2.9089 5.9 3.44305 5.9 4C5.9 4.55695 6.12125 5.0911 6.51508 5.48492C6.9089 5.87875 7.44305 6.1 8 6.1C8.55695 6.1 9.0911 5.87875 9.48492 5.48492C9.87875 5.0911 10.1 4.55695 10.1 4C10.1 3.44305 9.87875 2.9089 9.48492 2.51508C9.0911 2.12125 8.55695 1.9 8 1.9Z"
        fill={color}
      />
    </g>
  </svg>
);

// Override flagged item icon
export const OverrideIcon = ({ color = "#ffffff" }: IconProps) => (
  <svg width={iconWidth} height={iconHeight} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      transform="translate(2, 1)"
      d="M12.5 2L10.5 0H2.5C1.96957 0 1.46086 0.210714 1.08579 0.585786C0.710714 0.960859 0.5 1.46957 0.5 2V14C0.5 14.5304 0.710714 15.0391 1.08579 15.4142C1.46086 15.7893 1.96957 16 2.5 16H9.5V18L13.5 15L9.5 12V14H2.5V2H12.5ZM19.5 9V20C19.5 20.5304 19.2893 21.0391 18.9142 21.4142C18.5391 21.7893 18.0304 22 17.5 22H6.5C5.96957 22 5.46086 21.7893 5.08579 21.4142C4.71071 21.0391 4.5 20.5304 4.5 20V18H6.5V20H17.5V11H12.5V6H6.5V12H4.5V6C4.5 5.46957 4.71071 4.96086 5.08579 4.58579C5.46086 4.21071 5.96957 4 6.5 4H14.5L19.5 9Z"
      fill={color}
    />
  </svg>
);

// Sort arrow icon
export const TinyArrowIcon = ({ color = "#ffffff" }: IconProps) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      transform="translate(6.5, 4.5)"
      d="M0.0300293 9.91973H4.03003V0.999727L6.04003 0.969727V9.91973H10.03L5.03003 14.9197L0.0300293 9.91973Z"
      fill={color}
    />
  </svg>
);

// TODO: Check if it is deprecated
export const ChatBubbleIcon = ({ color = "#ffffff" }: IconProps) => (
  <svg width={iconWidth} height={iconHeight} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      transform="translate(1.2, 0.12) scale(0.9)"
      d="M1 22.5V24.9142L2.70711 23.2071L6.41421 19.5H20C21.6523 19.5 23 18.1523 23 16.5V4.5C23 2.84772 21.6523 1.5 20 1.5H4C2.34772 1.5 1 2.84772 1 4.5V22.5Z"
      fill={color}
      stroke={color}
      strokeWidth="2"
      fillOpacity="0.3"
    />
  </svg>
);

// Algorithm Labeled Icon
export const ComputerLabeledIcon = ({ color = "#ffffff" }: IconProps) => (
  <svg width={iconWidth} height={iconHeight} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g transform="translate(3, 3) scale(0.69)">
      <path
        d="M5.25 0.75C3.9975 0.75 3 1.7475 3 3V12C3 13.2525 3.9975 14.25 5.25 14.25H18.75C20.0025 14.25 21 13.2525 21 12V3C21 1.7475 20.0025 0.75 18.75 0.75H5.25ZM5.25 3H18.75V12H5.25V3ZM3 15.375C1.7475 15.375 0.75 16.3725 0.75 17.625V21C0.75 22.2525 1.7475 23.25 3 23.25H21C22.2525 23.25 23.25 22.2525 23.25 21V17.625C23.25 16.3725 22.2525 15.375 21 15.375H3ZM7.5 17.625H21V21H7.5V17.625ZM8.625 18.46875V20.15625H13.125V18.46875H8.625ZM15.375 18.46875V20.15625H19.875V18.46875H15.375Z"
        fill={color}
      />
    </g>
  </svg>
);

// Disagreement Icon
export const DisagreementIcon = ({ color = "#ffffff" }: IconProps) => (
  <svg width={iconWidth} height={iconHeight} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M12.9999 14.5H10.9999V12.5H12.9999V14.5ZM14.7999 9.5C14.4999 9.9 14.0999 10.1 13.6999 10.3C13.3999 10.5 13.2999 10.6 13.1999 10.8C12.9999 11 12.9999 11.2 12.9999 11.5H10.9999C10.9999 11 11.0999 10.7 11.2999 10.4C11.4999 10.2 11.8999 9.9 12.3999 9.6C12.6999 9.5 12.8999 9.3 12.9999 9.1C13.0999 8.9 13.1999 8.6 13.1999 8.4C13.1999 8.1 13.0999 7.9 12.8999 7.7C12.6999 7.5 12.3999 7.4 12.0999 7.4C11.7999 7.4 11.5999 7.5 11.3999 7.6C11.1999 7.7 11.0999 7.9 11.0999 8.2H8.9999C9.0999 7.5 9.4999 6.9 10.0999 6.5C10.6999 6.1 11.5999 6 12.0999 6C12.9999 6 13.7999 6.2 14.2999 6.6C14.7999 7 15.0999 7.6 15.0999 8.3C15.1999 8.7 15.0999 9.1 14.7999 9.5Z"
      fill={color}
    />
    <path
      d="M21 16H3V4H21M21 2H3C2.22 2 1.67 2.25 1.34 2.67C1.01 3.09 1 3.67 1 4V16C1 16.53 1.21 16.96 1.51 17.34C1.81 17.72 2.27 18 3 18H10V20H8V22H16V20H14V18H21C21.53 18 21.96 17.79 22.34 17.49C22.72 17.19 23 16.73 23 16V4C23 2.22 22.1 2 21 2Z"
      fill={color}
    />
  </svg>
);

// Demo page autotriggered icon
export function DemoAutoTriggerIcon({ color = "#ffffff" }: IconProps) {
  return (
    <svg width={iconWidth} height={iconHeight} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M4.94 6.35C4.55 5.96 4.55 5.32 4.94 4.93C5.33 4.54 5.96 4.54 6.35 4.93L13.07 10.31L13.42 10.59C14.2 11.37 14.2 12.64 13.42 13.42C12.64 14.2 11.37 14.2 10.59 13.42L10.31 13.07L4.94 6.35ZM12 20C14.1217 20 16.1566 19.1571 17.6569 17.6569C19.1571 16.1566 20 14.1217 20 12C20 9.79 19.1 7.79 17.66 6.34L19.07 4.93C20.88 6.74 22 9.24 22 12C22 14.6522 20.9464 17.1957 19.0711 19.0711C17.1957 20.9464 14.6522 22 12 22C10.6868 22 9.38642 21.7413 8.17317 21.2388C6.95991 20.7362 5.85752 19.9997 4.92893 19.0711C3.05357 17.1957 2 14.6522 2 12H4C4 14.1217 4.84285 16.1566 6.34315 17.6569C7.84344 19.1571 9.87827 20 12 20ZM12 1C12.5304 1 13.0391 1.21071 13.4142 1.58579C13.7893 1.96086 14 2.46957 14 3C14 3.53043 13.7893 4.03914 13.4142 4.41421C13.0391 4.78929 12.5304 5 12 5C11.4696 5 10.9609 4.78929 10.5858 4.41421C10.2107 4.03914 10 3.53043 10 3C10 2.46957 10.2107 1.96086 10.5858 1.58579C10.9609 1.21071 11.4696 1 12 1Z"
        fill={color}
      />
    </svg>
  );
}

// Gallery Dropzone Icon
export const GalleryDropzoneIcon = ({ color = "#ffffff" }: IconProps) => (
  <svg width="84" height="84" viewBox="0 0 84 84" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M21 59.5L31.5 45.955L38.99 54.985L49.49 40.95L63 59.5H21z"
      fill={color}
    />
    <path
      d="M10.5 10.5h63v63h-63z"
      stroke={color}
      strokeWidth="2"
      strokeDasharray="4 2"
    />
  </svg>
);

// Image Icon
export const ImageIcon = ({ color = "#ffffff" }: IconProps) => (
  <svg width="14" height="12" viewBox="0 0 14 12" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M12.5 0.835815H1.5C1.23478 0.835815 0.98043 0.941172 0.792893 1.12871C0.605357 1.31624 0.5 1.5706 0.5 1.83582V10.8358C0.5 11.101 0.605357 11.3554 0.792893 11.5429C0.98043 11.7305 1.23478 11.8358 1.5 11.8358H12.5C12.7652 11.8358 13.0196 11.7305 13.2071 11.5429C13.3946 11.3554 13.5 11.101 13.5 10.8358V1.83582C13.5 1.5706 13.3946 1.31624 13.2071 1.12871C13.0196 0.941172 12.7652 0.835815 12.5 0.835815ZM12.5 1.83582V8.25769L10.8706 6.62894C10.7778 6.53606 10.6675 6.46238 10.5462 6.41211C10.4248 6.36184 10.2948 6.33597 10.1634 6.33597C10.0321 6.33597 9.90204 6.36184 9.7807 6.41211C9.65936 6.46238 9.54911 6.53606 9.45625 6.62894L8.20625 7.87894L5.45625 5.12894C5.26873 4.94155 5.01448 4.83628 4.74937 4.83628C4.48427 4.83628 4.23002 4.94155 4.0425 5.12894L1.5 7.67144V1.83582H12.5ZM1.5 9.08582L4.75 5.83582L9.75 10.8358H1.5V9.08582ZM12.5 10.8358H11.1644L8.91438 8.58582L10.1644 7.33582L12.5 9.67207V10.8358ZM8 4.58582C8 4.43748 8.04399 4.29247 8.1264 4.16914C8.20881 4.0458 8.32594 3.94967 8.46299 3.89291C8.60003 3.83614 8.75083 3.82129 8.89632 3.85023C9.0418 3.87917 9.17544 3.9506 9.28033 4.05549C9.38522 4.16037 9.45665 4.29401 9.48559 4.4395C9.51453 4.58498 9.49967 4.73578 9.44291 4.87283C9.38614 5.00987 9.29001 5.12701 9.16668 5.20942C9.04334 5.29183 8.89834 5.33582 8.75 5.33582C8.55109 5.33582 8.36032 5.2568 8.21967 5.11615C8.07902 4.97549 8 4.78473 8 4.58582Z"
      fill={color}
    />
  </svg>
);

// Export Icon
export const ExportIcon = ({ color = "#ffffff" }: IconProps) => (
  <svg width={iconWidth} height={iconHeight} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g>
      <rect fill="none" height="24" width="24" />
    </g>
    <g>
      <path
        d="M18,15v3H6v-3H4v3c0,1.1,0.9,2,2,2h12c1.1,0,2-0.9,2-2v-3H18z M17,11l-1.41-1.41L13,12.17V4h-2v8.17L8.41,9.59L7,11l5,5 L17,11z"
        fill={color}
      />
    </g>
  </svg>
);

export const DeleteIcon = ({ color = "#ffffff" }: IconProps) => (
  <svg width={iconWidth} height={iconHeight} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M7.59721 21C7.12106 21 6.71344 20.8042 6.37436 20.4125C6.03528 20.0208 5.86574 19.55 5.86574 19V5.99999H5V3.99999H9.32869V2.99999H14.5231V3.99999H18.8518V5.99999H17.9861V19C17.9861 19.55 17.8165 20.0208 17.4774 20.4125C17.1384 20.8042 16.7307 21 16.2546 21H7.59721ZM16.2546 5.99999H7.59721V19H16.2546V5.99999ZM9.32869 17H11.0602V7.99999H9.32869V17ZM12.7916 17H14.5231V7.99999H12.7916V17Z"
      fill={color}
    />
  </svg>
);

export const ArrowSelectorIcon = ({ color = "#ffffff" }: IconProps) => (
  <svg width={iconWidth} height={iconHeight} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g transform="translate(7 2)">
      <path
        d="M2 11.75L3.975 9H8.225L2 4.1V11.75ZM7.775 20L4.15 12.2L0 18V0L14 11H6.9L10.5 18.725L7.775 20Z"
        fill={color}
      />
    </g>
  </svg>
);

export const LineIcon = ({ color = "#ffffff" }: IconProps) => (
  <svg width={iconWidth} height={iconHeight} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <line
      x1="4.29289"
      y1="19.2929"
      x2="18.2929"
      y2="5.29289"
      stroke={color}
      strokeWidth="2"
    />
  </svg>
);

export const StrokeWidthIcon = ({ color = "#ffffff", strokeWidth = "2" }: StrokeWidthIconProps) => (
  <svg width={iconWidth} height={iconHeight} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <line x1="1.14645" y1="21.1464" x2="21.1464" y2="1.14645" strokeWidth={strokeWidth} stroke={color} />
  </svg>
  );

export const InsertTextIcon = ({ color = "#ffffff" }: IconProps) => (
  <svg width={iconWidth} height={iconHeight} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M11 16V10H8V8H16V10H13V16H11ZM1 23V17H3V7H1V1H7V3H17V1H23V7H21V17H23V23H17V21H7V23H1ZM7 19H17V17H19V7H17V5H7V7H5V17H7V19ZM3 5H5V3H3V5ZM19 5H21V3H19V5ZM19 21H21V19H19V21ZM3 21H5V19H3V21Z"
      fill={color}
    />
  </svg>
);

export const InkEraserIcon = ({ color = "#ffffff" }: IconProps) => (
  <svg width={iconWidth} height={iconHeight} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M17.2499 18H21.9999V20H15.2499L17.2499 18ZM4.74988 20L2.62488 17.875C2.24154 17.4917 2.04571 17.0167 2.03738 16.45C2.02904 15.8833 2.21654 15.4 2.59988 15L13.5999 3.6C13.9832 3.2 14.454 3 15.0124 3C15.5707 3 16.0415 3.19167 16.4249 3.575L21.3999 8.55C21.7832 8.93333 21.9749 9.40833 21.9749 9.975C21.9749 10.5417 21.7832 11.0167 21.3999 11.4L12.9999 20H4.74988ZM12.1499 18L19.9999 9.95L15.0499 5L3.99988 16.4L5.59988 18H12.1499Z"
      fill={color}
    />
  </svg>
);

export const StrokeColorIcon = ({ color = "#ffffff", strokeWidth = "2" }: StrokeWidthIconProps) => (
  <svg width={iconWidth} height={iconHeight} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect x="4" y="4" width="16" height="16" stroke={color} strokeWidth={strokeWidth} fill="none" />
  </svg>
);

export const OpenInFullIcon = ({ color = "#ffffff" }: IconProps) => (
  <svg width={iconWidth} height={iconHeight} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      transform="translate(3, 3)"
      d="M0 18V10H2V14.6L14.6 2H10V0H18V8H16V3.4L3.4 16H8V18H0Z"
      fill={color} />
  </svg>
);


export const ExportCircleIcon = ({ color = "#ffffff" }: IconProps) => (
  <svg width={iconWidth} height={iconHeight} viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      transform="translate(3, 3)"
      d="M7.2 18V15.6H16.8V18H7.2ZM16.8 9.6L12 14.4L7.2 9.6H10.2V4.8H13.8V9.6H16.8ZM12 0C18.6 0 24 5.4 24 12C24 18.6 18.6 24 12 24C5.4 24 0 18.6 0 12C0 5.4 5.4 0 12 0ZM12 2.4C6.696 2.4 2.4 6.696 2.4 12C2.4 17.304 6.696 21.6 12 21.6C17.304 21.6 21.6 17.304 21.6 12C21.6 6.696 17.304 2.4 12 2.4Z"
      fill={color}
    />
  </svg>
);

// Eye Icon
export const EyeIcon = ({ color = "#ffffff" }: IconProps) => (
  <svg width={iconWidth} height={iconHeight} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g transform="translate(1.2, 1.2) scale(0.9)">
      <path d="M0 0h24v24H0V0z" fill="none" />
      <path
        d="M12 6.5c3.79 0 7.17 2.13 8.82 5.5-1.65 3.37-5.02 5.5-8.82 5.5S4.83 15.37 3.18 12C4.83 8.63 8.21 6.5 12 6.5m0-2C7 4.5 2.73 7.61 1 12c1.73 4.39 6 7.5 11 7.5s9.27-3.11 11-7.5c-1.73-4.39-6-7.5-11-7.5zm0 5c1.38 0 2.5 1.12 2.5 2.5s-1.12 2.5-2.5 2.5-2.5-1.12-2.5-2.5 1.12-2.5 2.5-2.5m0-2c-2.48 0-4.5 2.02-4.5 4.5s2.02 4.5 4.5 4.5 4.5-2.02 4.5-4.5-2.02-4.5-4.5-4.5z"
        fill={color}
      />
    </g>
  </svg>
);

// Grid View Icon
export const GridViewIcon = ({ color = "#ffffff" }: IconProps) => (
  <svg width={iconWidth} height={iconHeight} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M12 16C13.1 16 14 16.9 14 18C14 19.1 13.1 20 12 20C10.9 20 10 19.1 10 18C10 16.9 10.9 16 12 16ZM12 10C13.1 10 14 10.9 14 12C14 13.1 13.1 14 12 14C10.9 14 10 13.1 10 12C10 10.9 10.9 10 12 10ZM12 4C13.1 4 14 4.9 14 6C14 7.1 13.1 8 12 8C10.9 8 10 7.1 10 6C10 4.9 10.9 4 12 4ZM6 16C7.1 16 8 16.9 8 18C8 19.1 7.1 20 6 20C4.9 20 4 19.1 4 18C4 16.9 4.9 16 6 16ZM6 10C7.1 10 8 10.9 8 12C8 13.1 7.1 14 6 14C4.9 14 4 13.1 4 12C4 10.9 4.9 10 6 10ZM6 4C7.1 4 8 4.9 8 6C8 7.1 7.1 8 6 8C4.9 8 4 7.1 4 6C4 4.9 4.9 4 6 4ZM18 16C19.1 16 20 16.9 20 18C20 19.1 19.1 20 18 20C16.9 20 16 19.1 16 18C16 16.9 16.9 16 18 16ZM18 10C19.1 10 20 10.9 20 12C20 13.1 19.1 14 18 14C16.9 14 16 13.1 16 12C16 10.9 16.9 10 18 10ZM18 4C19.1 4 20 4.9 20 6C20 7.1 19.1 8 18 8C16.9 8 16 7.1 16 6C16 4.9 16.9 4 18 4Z"
      fill={color}
    />
  </svg>
);

export const ListViewIcon = ({ color = "#ffffff" }: IconProps) => (
  <svg width={iconWidth} height={iconHeight} viewBox="0 0 24 24" fill={color} xmlns="http://www.w3.org/2000/svg">
    <path d="M0 0h24v24H0V0z" fill="none" />
    <path d="M3 18h18v-2H3v2zm0-5h18v-2H3v2zm0-7v2h18V6H3z" />
  </svg>
);

export const GridBigViewIcon = ({ color = "#ffffff" }: IconProps) => (
  <svg width={iconWidth} height={iconHeight} viewBox="0 0 24 24" fill={color} xmlns="http://www.w3.org/2000/svg">
    <path d="M0 0h24v24H0V0z" fill="none" />
    <path d="M3 3v18h18V3H3zm8 16H5v-6h6v6zm0-8H5V5h6v6zm8 8h-6v-6h6v6zm0-8h-6V5h6v6z" />
  </svg>
);

// No Adult Content Icon used on Answer panel
export const NoAdultContentIcon = ({ color = "#ffffff" }: IconProps) => (
  <svg width={iconWidth} height={iconHeight} viewBox="0 0 24 24" fill={color}>
    <g>
      <rect fill="none" height="24" width="24" />
    </g>
    <g>
      <g>
        <path d="M12,2C6.48,2,2,6.48,2,12s4.48,10,10,10s10-4.48,10-10S17.52,2,12,2z M4,12c0-1.85,0.63-3.54,1.69-4.9L7.59,9h2.83 L7.1,5.69C8.46,4.63,10.15,4,12,4c4.41,0,8,3.59,8,8c0,1.85-0.63,3.54-1.69,4.9l-1.9-1.9h-2.83l3.31,3.31 C15.54,19.37,13.85,20,12,20C7.59,20,4,16.41,4,12z" /><polygon points="14.25,14 12.75,12 14.25,10 12.75,10 12,11 11.25,10 9.75,10 11.25,12 9.75,14 11.25,14 12,13 12.75,14" /><polygon points="8,10 7.25,11 6.5,10 5,10 6.5,12 5,14 6.5,14 7.25,13 8,14 9.5,14 8,12 9.5,10" />
        <polygon points="16,14 16.75,13 17.5,14 19,14 17.5,12 19,10 17.5,10 16.75,11 16,10 14.5,10 16,12 14.5,14" />
      </g>
    </g>
  </svg>
);

export const InfoOutlineIcon = ({ color = "#ffffff" }: IconProps) => (
  <svg width={iconWidth} height={iconHeight} viewBox="0 0 24 24" fill={color} xmlns="http://www.w3.org/2000/svg">
    <path d="M0 0h24v24H0V0z" fill="none" />
    <path
      d="M11 7h2v2h-2zm0 4h2v6h-2zm1-9C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8z"
      fill={color}
    />
  </svg>
);

// Settings Icon
export const SettingsIcon = ({ color = "#ffffff" }: IconProps) => (
  <svg width={iconWidth} height={iconHeight} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M9.25001 22L8.85001 18.8C8.63335 18.7167 8.42918 18.6167 8.23751 18.5C8.04585 18.3833 7.85835 18.2583 7.67501 18.125L4.70001 19.375L1.95001 14.625L4.52501 12.675C4.50835 12.5583 4.50001 12.4458 4.50001 12.3375V11.6625C4.50001 11.5542 4.50835 11.4417 4.52501 11.325L1.95001 9.375L4.70001 4.625L7.67501 5.875C7.85835 5.74167 8.05001 5.61667 8.25001 5.5C8.45001 5.38333 8.65001 5.28333 8.85001 5.2L9.25001 2H14.75L15.15 5.2C15.3667 5.28333 15.5708 5.38333 15.7625 5.5C15.9542 5.61667 16.1417 5.74167 16.325 5.875L19.3 4.625L22.05 9.375L19.475 11.325C19.4917 11.4417 19.5 11.5542 19.5 11.6625V12.3375C19.5 12.4458 19.4833 12.5583 19.45 12.675L22.025 14.625L19.275 19.375L16.325 18.125C16.1417 18.2583 15.95 18.3833 15.75 18.5C15.55 18.6167 15.35 18.7167 15.15 18.8L14.75 22H9.25001ZM11 20H12.975L13.325 17.35C13.8417 17.2167 14.3208 17.0208 14.7625 16.7625C15.2042 16.5042 15.6083 16.1917 15.975 15.825L18.45 16.85L19.425 15.15L17.275 13.525C17.3583 13.2917 17.4167 13.0458 17.45 12.7875C17.4833 12.5292 17.5 12.2667 17.5 12C17.5 11.7333 17.4833 11.4708 17.45 11.2125C17.4167 10.9542 17.3583 10.7083 17.275 10.475L19.425 8.85L18.45 7.15L15.975 8.2C15.6083 7.81667 15.2042 7.49583 14.7625 7.2375C14.3208 6.97917 13.8417 6.78333 13.325 6.65L13 4H11.025L10.675 6.65C10.1583 6.78333 9.67918 6.97917 9.23751 7.2375C8.79585 7.49583 8.39168 7.80833 8.02501 8.175L5.55001 7.15L4.57501 8.85L6.72501 10.45C6.64168 10.7 6.58335 10.95 6.55001 11.2C6.51668 11.45 6.50001 11.7167 6.50001 12C6.50001 12.2667 6.51668 12.525 6.55001 12.775C6.58335 13.025 6.64168 13.275 6.72501 13.525L4.57501 15.15L5.55001 16.85L8.02501 15.8C8.39168 16.1833 8.79585 16.5042 9.23751 16.7625C9.67918 17.0208 10.1583 17.2167 10.675 17.35L11 20ZM12.05 15.5C13.0167 15.5 13.8417 15.1583 14.525 14.475C15.2083 13.7917 15.55 12.9667 15.55 12C15.55 11.0333 15.2083 10.2083 14.525 9.525C13.8417 8.84167 13.0167 8.5 12.05 8.5C11.0667 8.5 10.2375 8.84167 9.56251 9.525C8.88751 10.2083 8.55001 11.0333 8.55001 12C8.55001 12.9667 8.88751 13.7917 9.56251 14.475C10.2375 15.1583 11.0667 15.5 12.05 15.5Z"
      fill={color}
    />
  </svg>
);

// Pencil Icon
export const EditIcon = ({ color = "#ffffff" }: IconProps) => (
  <svg width={iconWidth} height={iconHeight} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M5 19H6.425L16.2 9.225L14.775 7.8L5 17.575V19ZM3 21V16.75L16.2 3.575C16.4 3.39167 16.6208 3.25 16.8625 3.15C17.1042 3.05 17.3583 3 17.625 3C17.8917 3 18.15 3.05 18.4 3.15C18.65 3.25 18.8667 3.4 19.05 3.6L20.425 5C20.625 5.18333 20.7708 5.4 20.8625 5.65C20.9542 5.9 21 6.15 21 6.4C21 6.66667 20.9542 6.92083 20.8625 7.1625C20.7708 7.40417 20.625 7.625 20.425 7.825L7.25 21H3ZM15.475 8.525L14.775 7.8L16.2 9.225L15.475 8.525Z"
      fill={color}
    />
  </svg>
);

// Plus Icon
export const AddIcon = ({ color = "#ffffff" }: IconProps) => (
  <svg width={iconWidth} height={iconHeight} viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" fill={color}>
    <path d="M0 0h24v24H0V0z" fill="none" />
    <path d="M19 13h-6v6h-2v-6H5v-2h6V5h2v6h6v2z" />
  </svg>
);

// FlipCameraIos Icon
export const FlipCameraIos = ({ color = "#ffffff" }: IconProps) => (
  <svg  width={iconWidth} height={iconHeight} enableBackground="new 0 0 24 24" viewBox="0 0 24 24" fill={color} xmlns="http://www.w3.org/2000/svg">
    <g>
    <rect fill="none" height="24" width="24"/></g>
    <g><g><g><path d="M20,5h-3.17L15,3H9L7.17,5H4C2.9,5,2,5.9,2,7v12c0,1.1,0.9,2,2,2h16c1.1,0,2-0.9,2-2V7C22,5.9,21.1,5,20,5z M20,19H4V7 h3.17h0.88l0.59-0.65L9.88,5h4.24l1.24,1.35L15.95,7h0.88H20V19z"/></g><g><path d="M12,17c-2.21,0-4-1.79-4-4h2l-2.5-2.5L5,13h2c0,2.76,2.24,5,5,5c0.86,0,1.65-0.24,2.36-0.62l-0.74-0.74 C13.13,16.87,12.58,17,12,17z"/></g><g><path d="M12,8c-0.86,0-1.65,0.24-2.36,0.62l0.74,0.73C10.87,9.13,11.42,9,12,9c2.21,0,4,1.79,4,4h-2l2.5,2.5L19,13h-2 C17,10.24,14.76,8,12,8z"/></g></g></g>
    </svg>
);

// DiagonalArrow Icon
export const DiagonalArrow = ({ color = "#ffffff" }: IconProps) => (
  <svg width={iconWidth} height={iconHeight} enableBackground="new 0 0 24 24" viewBox="0 0 24 24" fill={color} xmlns="http://www.w3.org/2000/svg">
    <rect fill="none" height="24" width="24" />
    <path d="M9,5v2h6.59L4,18.59L5.41,20L17,8.41V15h2V5H9z" />
  </svg>
);

// Circle Icon
export const Circle = ({ color = "#ffffff" }: IconProps) => (
  <svg width={iconWidth} height={iconHeight} enableBackground="new 0 0 24 24" viewBox="0 0 24 24" fill={color} xmlns="http://www.w3.org/2000/svg">
    <g><rect fill="none" height="24" width="24" /></g>
    <g><path d="M12,2C6.47,2,2,6.47,2,12c0,5.53,4.47,10,10,10s10-4.47,10-10C22,6.47,17.53,2,12,2z M12,20c-4.42,0-8-3.58-8-8 c0-4.42,3.58-8,8-8s8,3.58,8,8C20,16.42,16.42,20,12,20z" />
    </g>
  </svg>
);

// CropSquare Icon
export const CropSquare = ({ color = "#ffffff" }: IconProps) => (
  <svg width={iconWidth} height={iconHeight} viewBox="0 0 24 24" fill={color} xmlns="http://www.w3.org/2000/svg">
    <path d="M0 0h24v24H0V0z" fill="none" />
    <path d="M18 4H6c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 14H6V6h12v12z" />
  </svg>
);

// Camera Icon
export const Camera = ({ color = "#ffffff" }: IconProps) => (
  <svg width={iconWidth} height={iconHeight} viewBox="0 0 24 24" fill={color} xmlns="http://www.w3.org/2000/svg">
    <path d="M0 0h24v24H0V0z" fill="none" />
    <path d="M20 4h-3.17L15 2H9L7.17 4H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 14H4V6h4.05l1.83-2h4.24l1.83 2H20v12zM12 7c-2.76 0-5 2.24-5 5s2.24 5 5 5 5-2.24 5-5-2.24-5-5-5zm0 8c-1.65 0-3-1.35-3-3s1.35-3 3-3 3 1.35 3 3-1.35 3-3 3z" />
  </svg>
);

// OpenInNew Icon
export const OpenInNewIcon = ({ color = "#ffffff" }: IconProps) => (
  <svg width={iconWidth} height={iconHeight} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M14 3V5H17.59L7.76 14.83L9.17 16.24L19 6.41V10H21V3H14ZM19 19H5V5H12V3H5C3.89 3 3 3.89 3 5V19C3 19.5304 3.21071 20.0391 3.58579 20.4142C3.96086 20.7893 4.46957 21 5 21H19C19.5304 21 20.0391 20.7893 20.4142 20.4142C20.7893 20.0391 21 19.5304 21 19V12H19V19Z"
      fill={color}
    />
  </svg>
);

// Equalizer Icon
export const EqualizerIcon = ({ color = "#ffffff" }: IconProps) => (
  <svg width={iconWidth} height={iconHeight} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g>
      <path d="M3 13V8H5.5V13H3ZM6.75 13V3H9.25V13H6.75ZM10.5 13V6.125H13V13H10.5Z" fill={color} />
    </g>
  </svg>
);
